import React, { Component } from 'react';
export const Page = props => (
  <div className="project">

    {/* ==== EDIT BELOW THIS LINE ==== */}
    
    <h1> "Get to Know Us": Hobby Icons </h1>

    <p>The below graphics were created to be a part of a series of employee features, pairing with 
    Expii's blog where employee feature interviews were housed. Based on how each employee 
    responded to interview questions, I created the below graphics for social media, illustrating 
    icons to represent each person's hobbies and interests.</p>

<div className="imgs max400">
            <div>
                <img 
                src={require('../assets/expiiIcons/11.jpg')} 
                data-skip-gallery
                    />
                <p>Post can be seen <a href="https://twitter.com/expii/status/908741026461945862" target="_blank">here</a>.</p>
            </div>
            <div>
                <img 
                src={require('../assets/expiiIcons/10.jpg')} 
                data-skip-gallery
                    />
                <p>Post can be seen <a href="https://www.instagram.com/p/BYyX6iyjYfU/" target="_blank">here</a>.</p>
            </div>
        </div>

<div className="imgs max400">
            <div>
                <img 
                src={require('../assets/expiiIcons/1.jpg')} 
                data-skip-gallery
                    />
                <p>Post can be seen <a href="https://www.instagram.com/p/BVr4YG8jc9d/?utm_source=ig_web_copy_link" target="_blank">here</a>.</p>
            </div>
            <div>
                <img 
                src={require('../assets/expiiIcons/2.jpg')} 
                data-skip-gallery
                    />
                <p>Post can be seen <a href="https://www.instagram.com/p/BWiC47BjZr7/?utm_source=ig_web_copy_link" target="_blank">here</a>.</p>
            </div>
        </div>
   
<div className="imgs max400">
            <div>
                <img 
                src={require('../assets/expiiIcons/9.jpg')} 
                data-skip-gallery
                    />
                <p>Post can be seen <a href="https://www.instagram.com/p/BYgKjA4DwfE/?utm_source=ig_web_copy_link" target="_blank">here</a>.</p>
            </div>
            <div>
                <img 
                src={require('../assets/expiiIcons/6.jpg')} 
                data-skip-gallery
                    />
                <p>Post can be seen <a href="https://www.instagram.com/p/BXqKTP5DaQc/?utm_source=ig_web_copy_link" target="_blank">here</a>.</p>
            </div>
        </div>

<div className="imgs max400">
            <div>
                <img 
                src={require('../assets/expiiIcons/5.jpg')} 
                data-skip-gallery
                    />
                <p>Post can be seen <a href="https://www.instagram.com/p/BXYcf_uDSO-/?utm_source=ig_web_copy_link" target="_blank">here</a>.</p>
            </div>
            <div>
                <img 
                src={require('../assets/expiiIcons/4.jpg')} 
                data-skip-gallery
                    />
                <p>Post can be seen <a href="https://www.instagram.com/p/BXGKBdDD1h4/?utm_source=ig_web_copy_link" target="_blank">here</a>.</p>
            </div>
        </div>

<div className="imgs max400">
            <div>
                <img 
                src={require('../assets/expiiIcons/3.jpg')} 
                data-skip-gallery
                    />
                <p>Post can be seen <a href="https://www.instagram.com/p/BW0kEjIDROg/?utm_source=ig_web_copy_link" target="_blank">here</a>.</p>
            </div>
            <div>
                <img 
                src={require('../assets/expiiIcons/8.jpg')} 
                data-skip-gallery
                    />
                <p>Post can be seen <a href="https://www.instagram.com/p/BYOsrmkDqdj/?utm_source=ig_web_copy_link" target="_blank">here</a>.</p>
            </div>
        </div>

<div className="imgs max400">
            <div>
                <img 
                src={require('../assets/expiiIcons/7.jpg')} 
                data-skip-gallery
                    />
                <p>Post can be seen <a href="https://www.instagram.com/p/BX8jScFjBLR/?utm_source=ig_web_copy_link" target="_blank">here</a>.</p>
            </div>
        </div>

    {/* ==== EDIT ABOVE THIS LINE ==== */}

  </div>
)